'use client';
import dynamic from 'next/dynamic';
import type { WorkingHoursProps } from './workingHours.types';
import s from './WorkinHours.module.scss';

const StatusOpen = dynamic(() => import('@/components/ui/StatusOpen/StatusOpen'), { ssr: false });

export const WorkingHours = ({ aggregatedSchedule, title, openTime, closeTime }: WorkingHoursProps) => {

  return (
    <div>
      <h3 className={s.title}>{title}</h3>
      <StatusOpen openTime={openTime} closeTime={closeTime} />
      <div className={s.schedule}>
        {aggregatedSchedule.map((item, index) => {
          const [day, value] = Object.entries(item)[0];
          return (
            <div key={index} className={s.schedule__row}>
              {value.open_time
                ? <span className={s.schedule__time}>{value.open_time} - {value.close_time}</span>
                : <span className={s.schedule__time_weekend}>{value.reason || 'Выходной день'}</span>
              }
              <span className={s.schedule__day}>{day}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};